<app-layout>
  <div class="privacy-policy">
    <div class="privacy-policy__header">
      <p class="h1 text-white">Política de Privacidade e Cookies</p>
      <p>Informe-se sobre a política de privacidade e cookies de nossa plataforma</p>
    </div>
  </div>
  <div class="container privacy-policy__description">
    <h2>INTRODUÇÃO</h2>
    <p>
      Inicialmente, a Plataforma da YES 7 TICKETS LTDA informa os usuários que a presente Política de Privacidade
      disponibiliza informações sobre o tratamento de dados pessoais de modo claro e facilitado. Com o intuito de
      facilitar o acesso às informações, será apresentado glossário, visando o adequado entendimento dos termos
      utilizados na regulamentação do tratamento de dados. Após a familiarização do consumidor com os termos utilizados,
      a YES 7 TICKETS LTDA discorrerá sobre a finalidade específica do tratamento, forma e duração, identificação e
      contato do controlador, informações sobre o uso compartilhado de dados, responsabilidade dos agentes de tratamento
      e os direitos do titular. Isto posto, é apresentada a Política de Cookies, conceituando termos importantes,
      demonstrando a finalidade dos Cookies utilizados e como pode ser realizado o gerenciamento desses. Em conclusão,
      são apresentadas as disposições gerais da Política de Privacidade e Cookies da Plataforma YES 7 TICKETS LTDA.
    </p>

    <h2>TERMOS INTRODUTÓRIOS</h2>
    <p>
      Os termos introdutórios expostos fundamentam-se, majoritariamente, na Lei nº 13.709, de 14 de agosto de 2018 — Lei
      Geral de Proteção de Dados Pessoais.
    </p>
    <ul>
      <li><strong>Dado pessoal:</strong> informação relacionada a pessoa natural identificada ou identificável.</li>
      <li>
        <strong>Dado pessoal sensível:</strong> dado pessoal sobre origem racial ou étnica, convicção religiosa, opinião
        política, filiação a sindicato ou a organização de caráter religioso, filosófico ou político, dado referente à
        saúde ou à vida sexual, dado genético ou biométrico, quando vinculado a uma pessoa natural.
      </li>
      <li>
        <strong>Dado anonimizado:</strong> dado relativo a titular que não possa ser identificado, considerando a
        utilização de meios técnicos razoáveis e disponíveis na ocasião de seu tratamento.
      </li>
      <li>
        <strong>Banco de dados:</strong> conjunto estruturado de dados pessoais, estabelecido em um ou vários locais, em
        suporte eletrônico ou físico.
      </li>
      <li>
        <strong>Titular:</strong> pessoa natural a quem se referem os dados pessoais que são objeto de tratamento.
      </li>
      <li>
        <strong>Controlador:</strong> pessoa natural ou jurídica, de direito público ou privado, a quem competem as
        decisões referentes ao tratamento de dados pessoais.
      </li>
      <li>
        <strong>Operador:</strong> pessoa natural ou jurídica, de direito público ou privado, que realiza o tratamento
        de dados pessoais em nome do controlador.
      </li>
      <li>
        <strong>Encarregado:</strong> pessoa indicada pelo controlador e operador para atuar como canal de comunicação
        entre o controlador, os titulares dos dados e a Autoridade Nacional de Proteção de Dados (ANPD).
      </li>
      <li><strong>Agentes de tratamento:</strong> o controlador e o operador.</li>
      <li>
        <strong>Tratamento:</strong> toda operação realizada com dados pessoais, como as que se referem a coleta,
        produção, recepção, classificação, utilização, acesso, reprodução, transmissão, distribuição, processamento,
        arquivamento, armazenamento, eliminação, avaliação ou controle da informação, modificação, comunicação,
        transferência, difusão ou extração.
      </li>
      <li>
        <strong>Anonimização:</strong> utilização de meios técnicos razoáveis e disponíveis no momento do tratamento,
        por meio dos quais um dado perde a possibilidade de associação, direta ou indireta, a um indivíduo.
      </li>
      <li>
        <strong>Consentimento:</strong> manifestação livre, informada e inequívoca pela qual o titular concorda com o
        tratamento de seus dados pessoais para uma finalidade determinada.
      </li>
      <li>
        <strong>Bloqueio:</strong> suspensão temporária de qualquer operação de tratamento, mediante guarda do dado
        pessoal ou do banco de dados.
      </li>
      <li>
        <strong>Eliminação:</strong> exclusão de dado ou de conjunto de dados armazenados em banco de dados,
        independentemente do procedimento empregado.
      </li>
      <li>
        <strong>Transferência internacional de dados:</strong> transferência de dados pessoais para país estrangeiro ou
        organismo internacional do qual o país seja membro.
      </li>
      <li>
        <strong>Uso compartilhado de dados:</strong> comunicação, difusão, transferência internacional, interconexão de
        dados pessoais ou tratamento compartilhado de bancos de dados pessoais por órgãos e entidades públicos no
        cumprimento de suas competências legais, ou entre esses e entes privados, reciprocamente, com autorização
        específica, para uma ou mais modalidades de tratamento permitidas por esses entes públicos, ou entre entes
        privados.
      </li>
      <li>
        <strong>Autoridade nacional:</strong> órgão da administração pública responsável por zelar, implementar e
        fiscalizar o cumprimento desta Lei em todo o território nacional.
      </li>
      <li>
        <strong>Cookies:</strong> arquivos de texto enviados e armazenados no seu navegador com o intuito de reconhecer,
        acompanhar e armazenar temporariamente sua navegação.
      </li>
      <li>
        <strong>Plataforma da Yes7 Tickets:</strong> plataforma disponibilizada para promover a intermediação entre os
        organizadores e os participantes, realizando a organização e venda de ingressos de eventos.
      </li>
      <li>
        <strong>Organizador:</strong> pessoa física ou jurídica que promove os eventos por intermédio da Plataforma da
        Yes7 Tickets.
      </li>
      <li><strong>Usuários:</strong> consumidores que navegam na Plataforma da Yes7 Tickets.</li>
      <li>
        <strong>Endereço de Protocolo da Internet — IP:</strong> responsável pela identificação e endereçamento dos
        dispositivos conectados em uma rede.
      </li>
    </ul>

    <h2>III. DO TRATAMENTO DOS DADOS PESSOAIS</h2>
    <h3>1. Finalidade específica do tratamento</h3>
    <p>
      1.1. A Yes7 Tickets é uma plataforma digital de inscrições, promovendo a intermediação na organização e venda de
      ingressos de eventos.
    </p>
    <p>
      1.2. Ao realizar o cadastro no site da Yes7 Tickets, deve ser fornecido o nome completo, e-mail, para
      concretização do login, e a criação de uma senha pelo usuário. Por intermédio da Interface de Programação de
      Aplicação — API do Facebook e Google, a conta poderá ser igualmente acessada. Para proceder ao cadastro ou
      realizar a compra de ingressos é necessário conceder autorização à Yes7 Tickets para a regular coleta dos dados
      pessoais.
    </p>
    <p>
      1.3. Para viabilizar a aquisição e identificação do ingresso, é necessário o fornecimento dos dados cadastrais
      indicados e o número do Cadastro de Pessoas Físicas — CPF, possibilitando a confirmação, pela Yes7 Tickets, da
      titularidade quando da realização do pagamento.
    </p>
    <p>
      1.4. Com o intuito de evitar fraudes, perpetradas por terceiros de má-fé, nos sistemas de segurança da plataforma,
      a Yes7 Tickets realiza a coleta do Endereço de Protocolo da Internet — IP e Cookies dos usuários, visando o
      cumprimento das obrigações legais.
    </p>
    <p>
      1.5. Os dados pessoais coletados pela Yes7 Tickets objetivam a execução do contrato, identificando o usuário
      cadastrado, sendo faculdade do titular a inserção de imagem, registrando-se as informações referentes ao ingresso
      adquirido. Com o propósito de atestar o cumprimento das regras previstas nos Termos e Condições de Uso, o
      tratamento fundamenta-se no consentimento do titular.
    </p>
    <p>
      1.6. O consentimento do titular para o tratamento de dados, autoriza o encaminhamento de e-mail de marketing pela
      Yes7 Tickets, recomendando eventos e enviando publicidades.
    </p>
    <p>
      1.7. Ao concretizar o cadastro na plataforma da Yes7 Tickets, o titular autoriza o tratamento dos dados pessoais
      para as finalidades apresentadas na presente Política de Privacidade. Havendo dúvidas sobre o funcionamento da
      plataforma e as condições do serviço, recomenda-se o acesso aos Termos e Condições de Uso.
    </p>
    <p>
      1.8. Ante o consentimento do titular, a Yes7 Tickets procederá ao envio de comunicados e notificações relevantes,
      referente às compras, alterações na Política de Privacidade e Termos e Condições de Uso, efetivando o adequado
      atendimento de suporte ao usuário, anunciações essas que são inerentes à plataforma.
    </p>
    <p>
      1.9. A Yes7 Tickets tratará os dados pessoais em harmonia com as hipóteses legalmente previstas, como para o
      cumprimento de obrigação legal, execução de contrato, execução regular de direitos, atendimento de interesses
      legítimos e para o exercício regular de direitos em processo judicial, administrativo ou arbitral.
    </p>
    <p>
      1.10. Na situação da Yes7 Tickets utilizar os dados pessoais de modo não compatível com o previsto na presente
      Política de Privacidade, será encaminhado previamente ao titular comunicado sobre esse específico tratamento de
      informações.
    </p>

    <h2>2. Forma e duração do tratamento de dados</h2>
    <p>
      2.1. Os dados pessoais serão utilizados conforme disposto nesta Política de Privacidade, visando facilitar o
      acesso à plataforma e aos serviços desenvolvidos pela Yes7 Tickets.
    </p>
    <p>
      2.2. A Yes7 Tickets realiza o tratamento de dados pessoais, por meios digitais, de pessoas naturais e jurídicas,
      em conformidade com a Lei Geral de Proteção de Dados Pessoais — Lei nº 13.709, de 14 de agosto de 2018.
    </p>
    <p>2.3. Deve-se discriminar as fases do tratamento de dados pessoais, qual sejam:</p>
    <ul>
      <li>
        2.3.1. Coleta: obtenção, recepção ou produção de dados pessoais, independente do meio utilizado. No caso da Yes7
        Tickets, a coleta é realizada via formulário online.
      </li>
      <li>2.3.2. Armazenamento: armazenamento de dados pessoais em meio eletrônico, físico, banco de dados.</li>
      <li>
        2.3.3. Utilização: operações que envolvam classificar, utilizar, reproduzir, processar, avaliar, controlar ou
        modificar os dados pessoais.
      </li>
      <li>2.3.4. Compartilhamento: operações que envolvam a transferência e o compartilhamento dos dados pessoais.</li>
    </ul>
    <p>
      2.4. Os dados pessoais serão tratados e operados em território nacional, objetivando a oferta e o fornecimento de
      serviços relacionados às funcionalidades da Yes7 Tickets, como a intermediação para organização e venda de
      ingresso de eventos.
    </p>
    <p>
      2.5. O controle dos dados pessoais será realizado pela Yes7 Tickets, a quem compete as decisões referentes ao
      tratamento das informações da pessoa natural. Os dados coletados durante o cadastro ou para viabilizar a aquisição
      dos ingressos são as informações estritamente necessárias para a concretização do ato, quais sejam: nome completo,
      número do Cadastro de Pessoas Físicas — CPF, e-mail, senha, fotografia pessoal de identificação (facultativo),
      endereço e número do Registro Geral — RG.
    </p>
    <p>
      2.6. Informa-se que a Yes7 Tickets não efetua a coleta ou tratamento de dados pessoais sensíveis dos titulares,
      portanto, não são objeto de tratamento as informações sobre origem racial ou étnica, religião, opinião política,
      filiação a sindicato ou organização de caráter religioso, filosófico ou político, saúde, vida sexual, dado
      genético ou biométrico.
    </p>

    <h2>IV. POLÍTICA DE COOKIES</h2>
    <h3>1.2. Conceitos iniciais</h3>
    <p><strong>Browsers:</strong> conhecidos como navegadores, são programas responsáveis pelo acesso à internet.</p>
    <p>
      <strong>Google Analytics:</strong> plataforma que coleta dados nos seus aplicativos e sites para criar relatórios
      para o empreendimento.
    </p>
    <p>
      <strong>Cookies analíticos:</strong> possibilitam a coleta de dados sobre a utilização do site pelos usuários,
      erros e informações sobre o desempenho do site ou plataforma.
    </p>
    <p>
      <strong>Cookies de funcionalidade:</strong> usados para fornecer serviços básicos ao usuário, programando para
      recordar preferências do sistema, como nome de usuário e idioma.
    </p>
    <p>
      <strong>Cookies de publicidade:</strong> utilizados para coletar informações sobre o titular dos dados pessoais
      visando exibir anúncios.
    </p>

    <h2>2.2. Cookies utilizados</h2>
    <p>
      2.2.1. Os Cookies são arquivos de texto armazenados nos navegadores (browsers), sendo os programas que viabilizam
      o acesso à internet, permitindo a compreensão pela Yes7 Tickets das ações e preferências dos usuários na
      plataforma, auxiliando a oferecer um serviço personalizado e relevante ao consumidor.
    </p>
    <p>
      2.2.2. A Yes7 Tickets, por intermédio dos Cookies, acessa a interação do usuário com o conteúdo disponibilizado na
      plataforma, possibilitando uma melhora na experiência do consumidor e o oferecimento de anúncios de produtos e
      serviços direcionados e personalizados aos interesses dos consumidores.
    </p>
    <p>
      2.2.3. A autenticação da conta é utilizada pela Yes7 Tickets para identificar os usuários conectados,
      possibilitando o oferecimento de recursos inerentes à plataforma. Acresce que esse mecanismo é empregado para
      viabilizar a “persistência de login”, mantendo o usuário conectado quando o navegador for encerrado.
    </p>
    <p>
      2.2.4. Com o propósito de analisar os comportamentos de navegação, visando proporcionar conteúdos personalizados e
      relevantes aos usuários, a Yes7 Tickets utiliza o Gerenciamento de métricas.
    </p>
    <p>
      2.2.5. As pesquisas com os usuários são realizadas de modo anonimizado, examinando as interações efetuadas na
      plataforma, com o intuito de aperfeiçoar e desenvolver as experiências entre Organizador e Consumidor.
    </p>
    <p>
      2.2.6. Para inspecionar e verificar as operações realizadas na plataforma, violações das políticas e da
      legislação, a Yes7 Tickets emprega o recurso de segurança da informação.
    </p>
    <p>
      2.2.7. Identificando o navegador e os dispositivos utilizados pelos usuários, com o propósito de otimizar a
      experiência ao longo do tempo, a Eventiva faz o uso da plataforma Google Analytics. Acesse o link para excluir o
      uso de Cookies:
      <a href="https://tools.google.com/dlpage/gaoptout/" target="_blank">https://tools.google.com/dlpage/gaoptout/</a>
    </p>

    <h2>3.2. Gerenciamento de cookies</h2>
    <p>
      3.2.1. O usuário pode administrar suas preferências de Cookies no próprio navegador, no entanto, ao excluir ou
      recusar os Cookies empregados pela Yes7 Tickets, deve estar ciente de que a negativa poderá comprometer a
      otimização das funcionalidades da plataforma que utilizam esta tecnologia como base.
    </p>
    <p>3.2.2. Para alterar as configurações de cookies, disponibilizamos os links dos principais navegadores:</p>

    <table class="table table-striped responsive">
      <thead>
        <tr>
          <th>
            <h2>Navegador</h2>
          </th>
          <th>
            <h2>Link de acesso</h2>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Internet Explorer</td>
          <td>
            <a
              href="https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies"
              target="_blank"
              >Gerenciar Cookies no Internet Explorer</a
            >
          </td>
        </tr>
        <tr>
          <td>Edge</td>
          <td>
            <a
              href="https://support.microsoft.com/pt-br/help/4468242/microsoft-edge-browsing-data-and-privacy"
              target="_blank"
              >Gerenciar Cookies no Edge</a
            >
          </td>
        </tr>
        <tr>
          <td>Chrome</td>
          <td>
            <a href="https://support.google.com/chrome/answer/95647" target="_blank">Gerenciar Cookies no Chrome</a>
          </td>
        </tr>
        <tr>
          <td>Safari</td>
          <td>
            <a href="https://support.apple.com/pt-br/guide/safari/sfri11471/mac" target="_blank"
              >Gerenciar Cookies no Safari</a
            >
          </td>
        </tr>
        <tr>
          <td>Opera</td>
          <td>
            <a href="https://www.opera.com/help/tutorials/security/privacy/" target="_blank"
              >Gerenciar Cookies no Opera</a
            >
          </td>
        </tr>
      </tbody>
    </table>

    <h2>V. DISPOSIÇÕES GERAIS</h2>
    <p>
      A violação dos termos previstos nos Termos de Uso e na Política de Privacidade e Cookies poderá implicar na
      suspensão de acesso do usuário. A depender da gravidade, o usuário cadastrado poderá ser imediatamente excluído da
      plataforma, medida essa utilizada pela Yes7 Tickets para evitar ofensas aos direitos previstos neste regulamento.
    </p>
    <p>
      Na medida que a Política de Privacidade e Cookies se mantém em constante aperfeiçoamento, é reservado à Yes7
      Tickets o direito de modificá-la, conforme a finalidade da plataforma.
    </p>
    <p>
      Ao aceitar e concordar com a Política de Privacidade e Cookies, o usuário garante a completa e irrestrita
      aceitação dos termos expostos.
    </p>
  </div>
</app-layout>
